import { News } from '@arpeggi/shared'
import { FC } from 'react'
import { styled } from '../../../../lib/stitches'
import { Spacer } from '../../../core/Components'
import { Flex } from '../../../core/Flex'
import Text from '../../../core/Text/Text'

const Container = styled('div', {
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  borderRadius: '$10',
  padding: '$24',
  aspectRatio: 3 / 2,
  transition: 'background 0.1s ease-out, transform 0.1s ease-out'
})

interface Props {
  news: News
  disableSegmentTracking?: boolean
}

const segmentNews = (news) => {
  window.analytics.track('Button Clicked', {
    button: 'News Card: ' + news,
    source: window.location.pathname,
    location: 'news header'
  })
}

export const NewsItem: FC<Props> = ({ news, disableSegmentTracking }) => {
  const handleClick = () => {
    segmentNews(news.metadata.title)
  }

  return (
    <a
      href={news.metadata.link}
      target="_blank"
      onClick={disableSegmentTracking ? null : handleClick}
    >
      <Container
        css={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.45) 100%), url(${news.image?.url})`,
          '&:hover': {
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), url(${news.image?.url})`,
            transform: 'translateY(-2px)'
          }
        }}
      >
        <Flex css={{ flexDirection: 'column', height: '100%' }}>
          <Spacer />
          <Text size="14" type="primary_inverted" css={{ marginBottom: '$8' }}>
            {news.metadata.subtitle}
          </Text>
          <Text size="24" type="primary_inverted" id="title-text">
            {news.metadata.title}
          </Text>
        </Flex>
      </Container>
    </a>
  )
}
